export class CustomPersonalDetailsObject {
    constructor(
        // Add any custom application fields here

    ) {

    }
}
